export default __webpack_public_path__ + "static/dead-fish-82f86e78ed3a2e06d41b2305ac147c71.jpg";